import React from 'react';

const TickWithCircle = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_153_16061)">
      <path
        d="M6.99984 1.16675C3.77984 1.16675 1.1665 3.78008 1.1665 7.00008C1.1665 10.2201 3.77984 12.8334 6.99984 12.8334C10.2198 12.8334 12.8332 10.2201 12.8332 7.00008C12.8332 3.78008 10.2198 1.16675 6.99984 1.16675ZM6.99984 11.6667C4.42734 11.6667 2.33317 9.57258 2.33317 7.00008C2.33317 4.42758 4.42734 2.33341 6.99984 2.33341C9.57234 2.33341 11.6665 4.42758 11.6665 7.00008C11.6665 9.57258 9.57234 11.6667 6.99984 11.6667ZM10.09 4.83738C9.86235 4.60807 9.49167 4.60741 9.26317 4.83592L5.83317 8.26592L4.73398 7.17097C4.50651 6.94438 4.13852 6.94473 3.91148 7.17177C3.68414 7.39911 3.68414 7.76772 3.91148 7.99506L5.83317 9.91675L10.0886 5.66133C10.3159 5.43397 10.3166 5.06554 10.09 4.83738Z"
        fill="#6B6C7B"
      />
    </g>
    <defs>
      <clipPath id="clip0_153_16061">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TickWithCircle;
